import { Box, Typography } from '@mui/material';
import ReusableOverview from './ReusableOverview';
import SEOBadge from './SEOBadge';
import ReusableSeo from './ReusableSeo';
import { useSeoInput } from '../../hooks/useSeoInput';
import { regexUrl } from '../../lib/util';
import { useNavigate, useParams } from 'react-router-dom';
import React from 'react';

const FriendTest = () => {
  return (
    <Box>
      <ReusableOverview
        message={
          'To make your website SEO standout consider factors such as descriptive anchor text and relevance of destination pages. '
        }
        passed={true}
      />
      <Typography
        variant="h4"
        sx={{
          my: 2
        }}>
        How to pass
      </Typography>
      <Typography variant="subtitle1">
        Make sure all of the webpage&apos;s links are functional, have relevant anchor text, have a
        high-quality destination page, and are free of errors like broken or overly frequent
        redirects in order to pass this test.
      </Typography>
      <SEOBadge type="success">
        <Box component={'pre'}>
          {`<-- correct format -->
          
<a href="https://www.example.com/products" title="View our latest products">Latest Products</a>
`}
        </Box>
      </SEOBadge>
      <SEOBadge type="error">
        <Box component={'pre'}>
          {`<-- wrong format -->

<a href="#" onclick="javascript:doSomething()">Click Here</a>
`}
        </Box>
      </SEOBadge>
    </Box>
  );
};

export default FriendTest;
export const FriendTestSearch = () => {
  const { url, setUrl, error, setError } = useSeoInput();
  const navigate = useNavigate();
  const params = useParams();
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(false);

    if (url && regexUrl(url)) return navigate(`/seo-result/${params.id}`);

    setError(true);
  };
  return (
    <ReusableSeo
      title="Friendly SEO Test"
      keywords="Friendly SEO Test"
      url={url}
      setUrl={setUrl}
      error={error}
      setError={setError}
      handleSubmit={handleSubmit}
    />
  );
};
